
import { fork } from 'redux-saga/effects'

import pageSaga from './page/sagas'


export default function* rootSaga() {
	yield fork(pageSaga);
}